"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlActionDialog = void 0;
var material_1 = require("@mui/material");
var action_dialog_state_enum_1 = require("../../shared/enums/action-dialog-state.enum");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var enums_1 = require("../../shared/enums");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var typeography_common_1 = require("../typeography/typeography.common");
var il_spinner_1 = require("../il-spinner/il-spinner");
var il_button_1 = require("../il-button/il-button");
var react_1 = __importDefault(require("react"));
function IlActionDialog(_a) {
    var onAction = _a.onAction, onClose = _a.onClose, open = _a.open, dialogState = _a.dialogState, title = _a.title, actionButtonLabel = _a.actionButtonLabel, _b = _a.actionButtonDisabled, actionButtonDisabled = _b === void 0 ? false : _b, _c = _a.successText, successText = _c === void 0 ? 'The action was successful' : _c, _d = _a.failureText, failureText = _d === void 0 ? 'The action failed' : _d, successTextSx = _a.successTextSx, failureTextSx = _a.failureTextSx, _e = _a.fullScreen, fullScreen = _e === void 0 ? false : _e, children = _a.children;
    function closeDialog() {
        onClose();
    }
    function doAction() {
        onAction();
    }
    function getContentGivenState(state) {
        switch (state) {
            case action_dialog_state_enum_1.ActionDialogState.CONFIRM:
                return children;
            case action_dialog_state_enum_1.ActionDialogState.LOADING:
                return react_1.default.createElement(il_spinner_1.ILSpinner, null);
            case action_dialog_state_enum_1.ActionDialogState.SUCCESS:
                return react_1.default.createElement(typeography_common_1.ILBody1, { sx: __assign({ textAlign: 'center' }, successTextSx) }, successText);
            case action_dialog_state_enum_1.ActionDialogState.FAILURE:
                return (react_1.default.createElement(typeography_common_1.ILBody1, { sx: __assign({ textAlign: 'center', color: 'error.main' }, failureTextSx) }, failureText));
        }
    }
    function getActionsGivenState(state) {
        switch (state) {
            case action_dialog_state_enum_1.ActionDialogState.CONFIRM:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(il_button_1.ILButton, { onClick: closeDialog, variant: enums_1.ButtonVariantEnum.OUTLINED, color: enums_1.ColorPaletteEnum.ERROR, sx: { height: '2.5rem', flex: 1 } }, "Cancel"),
                    react_1.default.createElement(il_button_1.ILButton, { onClick: doAction, disabled: actionButtonDisabled, variant: enums_1.ButtonVariantEnum.OUTLINED, sx: { height: '2.5rem', flex: 1 } }, actionButtonLabel)));
            case action_dialog_state_enum_1.ActionDialogState.LOADING:
                return null;
            case action_dialog_state_enum_1.ActionDialogState.FAILURE:
            case action_dialog_state_enum_1.ActionDialogState.SUCCESS:
                return (react_1.default.createElement(il_button_1.ILButton, { onClick: closeDialog, variant: enums_1.ButtonVariantEnum.OUTLINED, sx: { height: '2.5rem', width: '8rem' } }, "Close"));
        }
    }
    return (react_1.default.createElement(material_1.Dialog, { open: open, onClose: closeDialog, 
        // maxWidth={maxWidth}
        fullScreen: fullScreen, PaperProps: {
            sx: {
                backgroundColor: 'background.default',
                width: '100%',
                maxWidth: { sm: 'auto', md: '22.5rem' }, // 360px
            },
        } },
        react_1.default.createElement(material_1.IconButton, { onClick: closeDialog, "data-testid": "close-icon", sx: {
                position: 'absolute',
                mt: '0.6rem',
                mr: '0.6rem',
                top: 0,
                right: 0,
                width: '2.5rem',
                height: '2.5rem',
            } },
            react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON, size: enums_1.IconSizeEnum.SMALL })),
        react_1.default.createElement(material_1.DialogTitle, { component: "div" },
            react_1.default.createElement(typeography_common_1.ILH3, { sx: { textAlign: 'center' } }, title)),
        react_1.default.createElement(material_1.DialogContent, { sx: { py: 0 } }, getContentGivenState(dialogState)),
        react_1.default.createElement(material_1.DialogActions, { sx: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                py: '1.25rem',
                px: '1.5rem',
            } }, getActionsGivenState(dialogState))));
}
exports.IlActionDialog = IlActionDialog;
